import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

import {
  SPACING_RULES,
  BORDER_RADIUS_RULES,
  FONT_SIZE_RULES,
  HEIGHT_RULES,
  SIZE_RULES,
} from '../tailwind.constants'

type RulesMap = Record<string, string | readonly string[]>

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: Object.keys(SPACING_RULES as RulesMap),
      borderRadius: Object.keys(BORDER_RADIUS_RULES as RulesMap),
    },
    classGroups: {
      'font-size': [{ text: Object.keys(FONT_SIZE_RULES as RulesMap) }],
      h: [{ h: Object.keys(HEIGHT_RULES as RulesMap) }],
      size: [{ size: Object.keys(SIZE_RULES as RulesMap) }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
